import React, { useEffect, useState, useRef } from "react";
import PageHeader from "../Components/PageHeader";
import "../Styles/Message.css";
import { Button, Form, Input } from "antd";
import SearchSelect from "../Components/SearchSelect";
import { EditOutlined } from "@ant-design/icons";
import useGetApi from "../services/useGetApi";
import usePost from "../services/usePost";
import ChatCard from "../Components/Messages/ChatCard";

const Message = () => {
  const chatCardRef = useRef();

  const [form] = Form.useForm();
  const [isVisible, setIsVisible] = useState(false);
  const [activeChat, setActiveChat] = useState(null);

  const [userOptions, setUserOptions] = useState([]);
  const [messageText, setMessageText] = useState("");
  const bottomRef = useRef(null); 
  const [isSendMessageLoading, setIsSendMessageLoading] = useState(false);

  const [isUserLoading, userError, userData, getUserData] = useGetApi(
    `users`,
    [],
    true
  );

  const [isChatLoading, chatError, chatData, getChatData] = useGetApi(
    `messages/chat-users`,
    [],
    true
  );

  const [isPostLoading, postError, postData] = usePost();

  useEffect(() => {
    getUserData(`users`);
    getChatData(`messages/chat-users`);
  }, []);

  useEffect(() => {
    if (userData) {
      const options = userData.map((user) => ({
        value: user.id,
        label: `${user.firstName} ${user.lastName} <${user.email}>`,
      }));
      setUserOptions(options);
    }
  }, [userData]);

  const onFinish = async (val) => {
    let data = {
      receiver: val.recipient,
      message: val.message,
    };
    let result = await postData(`messages/sendmessage`, data);
    console.log("result", result);
    if (result && result.messageThreadCode) {
      form.resetFields();
      setIsVisible(false);
      await getChatData(`messages/chat-users`);
      let chatUser = userData.find((user) => user.id === result.receiver);
      setActiveChat({
        messageThreadCode: result.messageThreadCode,
        recipient: chatUser,
      });
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleMessage = () => {
    setIsVisible(!isVisible);

    setTimeout(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    }, 100); // Sm
  };


  const handleValueChange = (value) => {
    form.setFieldValue("recipient", value);
  };

  const handleSendMessageToActiveChat = async () => {
    if (isSendMessageLoading) {
      return;
    }
    let data = {
      messageThreadCode: activeChat.messageThreadCode,
      message: messageText,
      receiver: activeChat.recipient.id,
    };
    setIsSendMessageLoading(true);
    let result = await postData(`messages/sendmessage`, data);
    if (result && result.messageId) {
      getChatData(`messages/chat-users`);
      setMessageText("");
      handleRefreshChat();
      // setActiveChat({
      //   messageThreadCode: result.messageThreadCode,
      //   receiver: activeChat.recipient,
      // });
    }
    setIsSendMessageLoading(false);
  };

  const handleRefreshChat = () => {
    if (chatCardRef.current) {
      chatCardRef.current.refreshChat();
    }
  };

  return (
    <div>
      <div className="d-flex gap-3 px-3">
        <div className="mt-5 pt-5 d-flex flex-column gap-4 w-100">
          <PageHeader title={"Private Message"} />
          <div className="bg-white p-3 d-flex">
            <div className="container-fluid">
              <div className="row">
                <div className="col-4">
                  <button className="message_btn" onClick={handleMessage}>
                    New Message <EditOutlined />
                  </button>
                  <div className="mt-3 d-flex flex-column gap-2">
                    {chatData &&
                      chatData.map((item) => {
                        return (
                          <Button
                            key={item.messageThreadCode}
                            className={`user_message ${
                              activeChat?.messageThreadCode ===
                              item.messageThreadCode
                                ? "active"
                                : ""
                            }`}
                            onClick={() =>
                              setActiveChat({
                                messageThreadCode: item.messageThreadCode,
                                recipient: item.chatUser,
                              })
                            }
                          >
                            <span className="user_message_user">{`${item.chatUser.firstName} ${item.chatUser.lastName}`}</span>
                            <span
                              className={`user_message_timestamp ${
                                activeChat?.messageThreadCode ===
                                item.messageThreadCode
                                  ? "active"
                                  : ""
                              }`}
                            >
                              {item.lastMessageTimestamp}
                            </span>
                          </Button>
                        );
                      })}
                  </div>
                </div>
                <div className="col-8">
                  {activeChat && (
                    <ChatCard ref={chatCardRef} chat={activeChat} />
                  )}
                  {activeChat && (
                    <div style={{ padding: "10px" }}>
                      <div className="chat-input-container">
                        <Input
                          value={messageText}
                          onChange={(e) => setMessageText(e.target.value)}
                          placeholder="Type a message..."
                          onPressEnter={handleSendMessageToActiveChat}
                        />
                        <Button
                          type="primary"
                          onClick={() => handleSendMessageToActiveChat()}
                          loading={isSendMessageLoading}
                        >
                          Send
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {isVisible && (
            <div>
              <Form
                name={"basic"}
                form={form}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  name="recipient"
                  rules={[
                    { required: true, message: "Please select a recipient!" },
                  ]}
                >
                  <SearchSelect
                    label="Recipient"
                    treeData={userOptions}
                    onChangeValue={handleValueChange}
                  />
                </Form.Item>
                <Form.Item
                  name="message"
                  rules={[
                    { required: true, message: "Please input your message!" },
                  ]}
                >
                  <Input.TextArea placeholder="Type your message here..." />
                </Form.Item>
                <Form.Item label={null}>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Message;
